import type { FC } from 'react';

export const CalendarIllustration: FC = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0653 45.6875H108V98.4875C108 104.321 103.264 109.058 97.4295 109.058H30.6358C24.8018 109.058 20.0653 104.321 20.0653 98.4875V45.6875Z"
      fill="#F8B1DC"
    />
    <path
      d="M30.3353 26.2109H97.6647C103.369 26.2109 108 30.842 108 36.5463V45.6868H20V36.5463C20 30.842 24.6311 26.2109 30.3353 26.2109Z"
      fill="#EE399E"
    />
    <path
      d="M38.1762 18.9414H38.1762C35.7991 18.9414 33.8721 20.8684 33.8721 23.2455V33.1752C33.8721 35.5523 35.7991 37.4793 38.1762 37.4793H38.1762C40.5533 37.4793 42.4803 35.5523 42.4803 33.1752V23.2455C42.4803 20.8684 40.5533 18.9414 38.1762 18.9414Z"
      fill="#0D3880"
    />
    <path
      d="M89.8235 18.9414H89.8235C87.4464 18.9414 85.5194 20.8684 85.5194 23.2455V33.1752C85.5194 35.5523 87.4464 37.4793 89.8235 37.4793H89.8235C92.2006 37.4793 94.1276 35.5523 94.1276 33.1752V23.2455C94.1276 20.8684 92.2006 18.9414 89.8235 18.9414Z"
      fill="#0D3880"
    />
    <path
      d="M73.5574 56.5723H68.8916C67.8873 56.5723 67.0732 57.3864 67.0732 58.3906V63.0564C67.0732 64.0607 67.8873 64.8747 68.8916 64.8747H73.5574C74.5616 64.8747 75.3757 64.0607 75.3757 63.0564V58.3906C75.3757 57.3864 74.5616 56.5723 73.5574 56.5723Z"
      fill="#EE399E"
    />
    <path
      d="M59.1092 71.0215H54.4433C53.4391 71.0215 52.625 71.8356 52.625 72.8398V77.5056C52.625 78.5099 53.4391 79.324 54.4433 79.324H59.1092C60.1134 79.324 60.9275 78.5099 60.9275 77.5056V72.8398C60.9275 71.8356 60.1134 71.0215 59.1092 71.0215Z"
      fill="#EE399E"
    />
    <path
      d="M44.6607 56.5723H39.9948C38.9906 56.5723 38.1765 57.3864 38.1765 58.3906V63.0564C38.1765 64.0607 38.9906 64.8747 39.9948 64.8747H44.6607C45.6649 64.8747 46.479 64.0607 46.479 63.0564V58.3906C46.479 57.3864 45.6649 56.5723 44.6607 56.5723Z"
      fill="white"
    />
    <path
      d="M59.1092 56.5723H54.4433C53.4391 56.5723 52.625 57.3864 52.625 58.3906V63.0564C52.625 64.0607 53.4391 64.8747 54.4433 64.8747H59.1092C60.1134 64.8747 60.9275 64.0607 60.9275 63.0564V58.3906C60.9275 57.3864 60.1134 56.5723 59.1092 56.5723Z"
      fill="white"
    />
    <path
      d="M88.0056 56.5723H83.3398C82.3356 56.5723 81.5215 57.3864 81.5215 58.3906V63.0564C81.5215 64.0607 82.3356 64.8747 83.3398 64.8747H88.0056C89.0099 64.8747 89.824 64.0607 89.824 63.0564V58.3906C89.824 57.3864 89.0099 56.5723 88.0056 56.5723Z"
      fill="#EE399E"
    />
    <path
      d="M44.6607 71.0215H39.9948C38.9906 71.0215 38.1765 71.8356 38.1765 72.8398V77.5056C38.1765 78.5099 38.9906 79.324 39.9948 79.324H44.6607C45.6649 79.324 46.479 78.5099 46.479 77.5056V72.8398C46.479 71.8356 45.6649 71.0215 44.6607 71.0215Z"
      fill="white"
    />
    <path
      d="M73.5574 71.0215H68.8916C67.8873 71.0215 67.0732 71.8356 67.0732 72.8398V77.5056C67.0732 78.5099 67.8873 79.324 68.8916 79.324H73.5574C74.5616 79.324 75.3757 78.5099 75.3757 77.5056V72.8398C75.3757 71.8356 74.5616 71.0215 73.5574 71.0215Z"
      fill="#EE399E"
    />
    <path
      d="M88.0056 71.0215H83.3398C82.3356 71.0215 81.5215 71.8356 81.5215 72.8398V77.5056C81.5215 78.5099 82.3356 79.324 83.3398 79.324H88.0056C89.0099 79.324 89.824 78.5099 89.824 77.5056V72.8398C89.824 71.8356 89.0099 71.0215 88.0056 71.0215Z"
      fill="white"
    />
    <path
      d="M44.6607 85.4688H39.9948C38.9906 85.4688 38.1765 86.2828 38.1765 87.2871V91.9529C38.1765 92.9571 38.9906 93.7712 39.9948 93.7712H44.6607C45.6649 93.7712 46.479 92.9571 46.479 91.9529V87.2871C46.479 86.2828 45.6649 85.4688 44.6607 85.4688Z"
      fill="white"
    />
    <path
      d="M59.1092 85.4688H54.4433C53.4391 85.4688 52.625 86.2828 52.625 87.2871V91.9529C52.625 92.9571 53.4391 93.7712 54.4433 93.7712H59.1092C60.1134 93.7712 60.9275 92.9571 60.9275 91.9529V87.2871C60.9275 86.2828 60.1134 85.4688 59.1092 85.4688Z"
      fill="white"
    />
    <path
      d="M73.5574 85.4688H68.8916C67.8873 85.4688 67.0732 86.2828 67.0732 87.2871V91.9529C67.0732 92.9571 67.8873 93.7712 68.8916 93.7712H73.5574C74.5616 93.7712 75.3757 92.9571 75.3757 91.9529V87.2871C75.3757 86.2828 74.5616 85.4688 73.5574 85.4688Z"
      fill="#EE399E"
    />
    <path
      d="M88.0056 85.4688H83.3398C82.3356 85.4688 81.5215 86.2828 81.5215 87.2871V91.9529C81.5215 92.9571 82.3356 93.7712 83.3398 93.7712H88.0056C89.0099 93.7712 89.824 92.9571 89.824 91.9529V87.2871C89.824 86.2828 89.0099 85.4688 88.0056 85.4688Z"
      fill="white"
    />
  </svg>
);
